import { render } from "./CompaniesView.vue?vue&type=template&id=67c2e1e9&ts=true"
import script from "./CompaniesView.vue?vue&type=script&lang=ts"
export * from "./CompaniesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__